import { Component, ViewChild, AfterViewInit, Input, OnInit, ElementRef, Inject, ChangeDetectionStrategy, ChangeDetectorRef, DoCheck, OnDestroy } from '@angular/core';
import { MAT_DIALOG_DATA, MatDialog, MatDialogRef } from '@angular/material/dialog';
import { UserService } from '../../../core/services/user.service';
import { MerchantSettingsService } from '../../../contexts-merchants/settings/merchants-settings.service';
import { SettingsService } from '../../../contexts/settings/settings.service';
import * as FileSaver from 'file-saver';
import { ToastrService } from 'ngx-toastr';
import { TranslateService } from '@ngx-translate/core';
import { ActivatedRoute, Router } from '@angular/router';

@Component({
  selector: 'app-notification-center',
  templateUrl: './notification-center.component.html',
  styleUrls: ['./notification-center.component.scss']
})
export class NotificationCenterComponent implements OnInit, OnDestroy {
  model: any = {};
  url: any;
  groupedNotifications: { [date: string]: any[] } = {};
  private intervalId: any;

  constructor(
    @Inject(MAT_DIALOG_DATA) public data: any,
    private cdr: ChangeDetectorRef,
    private dialog: MatDialog,
    private route: ActivatedRoute,
    private dialogRef: MatDialogRef<NotificationCenterComponent>,
    private userService: UserService,
    private merchantSettingsService: MerchantSettingsService,
    private toastr: ToastrService,
    private translateService: TranslateService,
    public settingsService: SettingsService,
  ) {
    this.data = data;
  }

  ngOnInit() {
    this.model.open = true;

    this.model.partner = this.data.partner;
    this.model.account = this.data.account;
    this.model.merchant = this.data.merchant;

    console.log("partner:", this.model.partner, "account:", this.model.account, "merchant:", this.model.merchant);

    this.model.user = this.userService.getUser();

    this.updateNotifications();
    this.cdr.detectChanges();
    this.startAutoUpdate();
  }

  groupNotificationsByCreationDate() {
    const notifications = JSON.parse(localStorage.getItem('notifications')) || [];

    this.groupedNotifications = notifications.reduce((acc: { [key: string]: any[] }, notification: any) => {
      const formattedDate = this.formatDate(notification.creation_date);
      if (!acc[formattedDate]) {
        acc[formattedDate] = [];
      }
      acc[formattedDate].push(notification);
      return acc;
    }, {});

    this.filterNotifications();
    this.cdr.detectChanges();
  }

  filterNotifications() {
    let notifications = JSON.parse(localStorage.getItem('notifications')) || [];

    for (const date in this.groupedNotifications) {
      this.groupedNotifications[date] = this.groupedNotifications[date].map((notification: any) => {
        notification.hidden = this.isNotificationHidden(notification);
        return notification;
      }).filter(notification => !notification.hidden);
    }

    notifications = notifications.map((notification: any) => {
      notification.hidden = this.isNotificationHidden(notification);
      return notification;
    });

    localStorage.setItem('notifications', JSON.stringify(notifications));
  }

  isNotificationHidden(notification: any): boolean {
    const isGeneralNotification = notification.partner == null && notification.merchant == null && notification.account == null;
    const partnerMismatch = notification.partner != null && notification.partner !== this.model.partner;
    const merchantMismatch = notification.merchant != null && notification.merchant !== this.model.merchant;
    const accountMismatch = notification.account != null && notification.account !== this.model.account;
    return !isGeneralNotification && (partnerMismatch || merchantMismatch || accountMismatch);
  }

  getVisibleNotifications() {
    return Object.keys(this.groupedNotifications).reduce((acc, date) => {
      acc[date] = this.groupedNotifications[date].filter(notification => !notification.hidden);
      return acc;
    }, {});
  }

  formatDate(date: string): string {
    const options: Intl.DateTimeFormatOptions = { year: '2-digit', month: 'short', day: '2-digit' };
    const formattedDate = new Date(date).toLocaleDateString('en-GB', options).replace(',', '').replace(/\//g, ' ');
    return formattedDate;
  }

  markAllAsRead() {
    let notifications = JSON.parse(localStorage.getItem('notifications')) || [];

    notifications = notifications.map((notification: any) => ({
      ...notification,
      read: true
    }));

    localStorage.setItem('notifications', JSON.stringify(notifications));
    this.updateNotifications();
  }

  ngOnDestroy(): void {
    clearInterval(this.intervalId);
  }

  openUrl(urlPath: string) {
    this.url = urlPath;
    window.open(this.url, '_blank');
  }

  startAutoUpdate() {
    this.intervalId = setInterval(() => {
      this.groupNotificationsByCreationDate();
    }, 5000);
  }

  getNotificationDates(): string[] {
    return Object.keys(this.groupedNotifications);
  }

  loadContent(id) {
    const notifications = JSON.parse(localStorage.getItem('notifications')) || [];
    const notification = notifications.find((n: any) => n.report_request_id === id);

    if (this.model.user.portal == "merchant") {
      this.merchantSettingsService.getReportsById(notification.partner, notification.account, notification.merchant, id)
        .subscribe((response) => {
          this.model.partner_report = response.partner_reports;
          this.updateLocalStorage(notification, response.partner_reports);
        });
    } else {
      this.settingsService.getReportsById(notification.partner, notification.account, id)
        .subscribe((response) => {
          this.model.partner_report = response.partner_reports;
          this.updateLocalStorage(notification, response.partner_reports);
        });
    }
  }

  updateLocalStorage(notification: any, updatedReport: any) {
    const notifications = JSON.parse(localStorage.getItem('notifications')) || [];
    const index = notifications.findIndex((n: any) => n.report_request_id === notification.report_request_id);

    if (index !== -1) {
      notifications[index] = { ...notification, ...updatedReport };
      localStorage.setItem('notifications', JSON.stringify(notifications));
      this.groupNotificationsByCreationDate();
      this.cdr.detectChanges();
    }
    this.checkEmptyState();
  }

  checkEmptyState() {
    const notifications = JSON.parse(localStorage.getItem('notifications')) || [];
    const visibleNotifications = notifications.filter(notification => !notification.hidden);
    this.model.emptyState = notifications.length === 0 || visibleNotifications.length === 0;
    console.log(this.model.emptyState);
  }

  download(partner, account, merchant, id) {
    const notifications = JSON.parse(localStorage.getItem('notifications')) || [];
    const notification = notifications.find((n: any) => n.report_request_id === id);

    console.log(notification);

    if (notification) {
      this.model.partner_report = notification;
    }


    if (this.model.user.portal == "merchant") {
      this.merchantSettingsService.download(partner, account, merchant, { report_request_id: notification.report_request_id, filename: notification.report_path })
        .subscribe({
          next: (response) => {

            var fileExt = notification.report_request_obj.file_name.split('.').pop();

            const file = new Blob([response], { type: fileExt == 'xlsx' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'text/csv' });
            FileSaver.saveAs(file, notification.report_request_obj.file_name);
            this.toastr.success(this.translateService.instant('transactions.messages.success.download'));
          },
          error: (error) => {

          }
        });
    } else {
      this.settingsService.download(partner, account, { report_request_id: notification.report_request_id, filename: notification.report_path })
        .subscribe({
          next: (response) => {

            var fileExt = notification.report_request_obj.file_name.split('.').pop();

            const file = new Blob([response], { type: fileExt == 'xlsx' ? 'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet' : 'text/csv' });
            FileSaver.saveAs(file, notification.report_request_obj.file_name);
            this.toastr.success(this.translateService.instant('transactions.messages.success.download'));
          },
          error: (error) => {

          }
        });
    }
  }

  markAsRead(id: string) {
    const notifications = JSON.parse(localStorage.getItem('notifications')) || [];

    const notification = notifications.find((r: any) => r.report_request_id === id);

    if (notification) {
      notification.read = true;
      localStorage.setItem('notifications', JSON.stringify(notifications));
      this.groupNotificationsByCreationDate();
    } else {
      console.warn(`Relatório com ID ${id} não encontrado.`);
    }
  }

  checkAndLimitNotifications() {
    let notifications = JSON.parse(localStorage.getItem('notifications')) || [];

    while (notifications.length > 20) {
      notifications.shift();
    }

    localStorage.setItem('notifications', JSON.stringify(notifications));
  }

  close() {
    this.dialogRef.close();
    this.groupNotificationsByCreationDate();
    this.cdr.detectChanges();
    this.startAutoUpdate();
  }

  updateNotifications() {
    this.groupNotificationsByCreationDate();
    this.checkEmptyState();
  }
}
